// @ts-nocheck
import React, { createRef } from "react";
import ProcedureBlock from "../../../../base/basicComponents/procedureBlock";
import TaskInformation from "../../../sections/taskInfoSections";
import PageHeader from "../../../commonComponents/pageHeaders/PageHeader";
import ReadOnlyProcedureFileSection from "../../../sections/procedureFileSections/readOnlyProcedureFileSection";
import ReadOnlySupportingFileSection from "../../../sections/supportingFileSections/readOnlySupportingFileSection";
import ActiveShareTaskReadOnly from "../../../sections/sharedTaskSections/activeShareTaskReadOnly";
import styles from "../index.module.scss";
import ApproveChangePPOService from "../../../../service/changePPO/ApproveChangePPOService";
import ReassignProcedureInformation from "../../../sections/procedureInfoSections/reassignProcedureInfoSection";
import ProcessBase from "../../../commonComponents/processBase";
import NormalSpin from "../../../../base/basicComponents/spin";
import StepBusinessType from "../../../../service/stepBase/stepBusinessType";
import StepService from "../../../../service/stepBase/StepService";
import CompleteStepBusinessType from "../../../../service/stepBase/completeStepBusinessType";
import ApproveChangePPOStepService from "../../../../service/changePPO/approveChangePPOStepService";
import { disableInteraction, enableInteraction } from "utils";

const procedureFileRef = createRef();
const supportingFileRef = createRef();
const procedureInfoRef = createRef();
export default class ReassignPPOPending extends ProcessBase {
  constructor(props: any) {
    super(props);
    this.state = {
      loading: false,
      pageHeadState: {
        receiveDate: null,
        requestByName: null,
        procedureStepStatus: null,
      },
      procedureFileData: {
        procedureTableData: [],
        clientServerPath: null,
        savedInRadioValue: null,
      },
      supportingFileData: [],
      procedureInfoState: {},
      taskInformationData: [],
      shareTask: {
        mainTaskAccountId: null,
        procedureProcessID: null,
        reason: null,
        returnReasonLogs: null,
        shareTaskAccountId: null,
        shareTaskProcedureStepID: null,
        shareTasks: [],
        submitReasonLogs: null,
      },
      jbProcedureSavedIn: null,
    };
    // @ts-ignore
    this.procedureTableData = [];
    // @ts-ignore
    this.procedureTaskId = this._getRoutingParam("ProcedureTaskId");
    // @ts-ignore
    this.procedureID = this._getRoutingParam("ProcedureID");
    // @ts-ignore
    this.procedureStepID = this._getRoutingParam("ProcedureStepID");
  }

  _showLoading = () => {
    disableInteraction();
    this.setState({ loading: true });
  };

  _hideLoading = async () => {
    await enableInteraction();
    this.setState({ loading: false });
  };

  closePage = () => {
    // @ts-ignore
    window.location = "/ToDoList";
  };

  /* function about adjust data when get data from api */
  handleDataNull = (file: any, key: any) => {
    if (file[key] === null) {
      if (key === "procedureFileID") {
        return 0;
      } else {
        return null;
      }
    } else {
      return file[key];
    }
  };

  setProcedureFileData = (result: any) => {
    if (result.procedureFolder !== null) {
      this.setProcedureTableData(result.procedureFolder);
      this.setState({
        procedureFileData: {
          savedInRadioValue:
            result.procedureFolder !== null
              ? result.procedureFolder.procedureSaveInCategoryID
              : null,
          clientServerPath:
            result.procedureFolder !== null ? result.procedureFolder.clientServerPath : "",
          // @ts-ignore
          procedureTableData: this.procedureTableData,
        },
        // @ts-ignore
        supportingFileData: this.supportingTableData,
        jbProcedureSavedIn:
          result.procedureFolder === null ? null : result.procedureFolder.jbProcedureSaveIn,
      });
    }
  };

  setSupportingFileData = (result: any) => {
    if (result.supportingFolder !== null) {
      this.setSupportingTableData(result);
      this.setState({
        // @ts-ignore
        supportingFileData: this.supportingTableData,
      });
    }
  };

  setShareTaskData = (result: any) => {
    if (result.shareTask === null || result.shareTask === undefined) {
      return;
    }

    this.setState({
      shareTask: result.shareTask,
    });
  };

  _getPrimaryProcedureOwnerStepItemSuccess = (response: any, flowDataResult: any) => {
    const result = { ...response, ...flowDataResult };
    const {
      reviceDate,
      requestByName,
      primaryProcedureOwner,
      procedureOwner,
      procedureNote,
      shareTask,
      applyPmpExcluded,
      procedureFolder,
      procedureStepStatus,
      workflowProcessInstanceId,
      procedureStatusID,
      statusCode,
      message,
      taskInfomation,
    } = result;
    if (statusCode === 401) {
      this._alertError(message);
    } else {
      this.setProcedureTableData(procedureFolder);
      this.setSupportingTableData(result);
      this.setState({
        pageHeadState: {
          receiveDate: this._formateDate(reviceDate),
          requestByName,
          procedureStepStatus,
        },
        procedureInfoState: {
          ...this.state.procedureInfoState,
          primaryProcedureOwner,
          procedureOwner: procedureOwner,
          workflowProcessInstanceId,
          isExcluded: applyPmpExcluded?.isExcluded ? "Yes" : "No",
          procedureNote,
          procedureStatus: procedureStatusID,
        },
        shareTask,
        procedureFileData: {
          savedInRadioValue: result.procedureFolder?.procedureSaveInCategoryID || null,
          clientServerPath:
            result.procedureFolder !== null ? result.procedureFolder.clientServerPath : "",
          // @ts-ignore
          procedureTableData: this.procedureTableData,
        },
        // @ts-ignore
        supportingFileData: this.supportingTableData,
        jbProcedureSavedIn:
          result.procedureFolder === null ? null : result.procedureFolder.jbProcedureSaveIn,
        taskInformationData: taskInfomation,
      });
      this._hideLoading();
    }
  };

  _getPrimaryProcedureOwnerStepItemFailed = () => {
    console.log("Get Primary Procedure Owner Step Item Failed");
  };

  _getFlowDataSuccess = (result: any, param: any) => {
    const { procedureStepStatus } = result;
    let mergePayloadMap = undefined;

    StepService.setStepInterfaceMergePayload(result, {
      isShareTaskProcess: false,
      isHistorical: procedureStepStatus === "Complete",
      // @ts-ignore
      procedureStepId: this.procedureStepID,
      // @ts-ignore
      procedureTaskId: this.taskID,
    });

    if (procedureStepStatus === "Complete") {
      ApproveChangePPOStepService.getProcedureOwnerStepKey = () =>
        CompleteStepBusinessType.procedureOwner;
      ApproveChangePPOStepService.getPMPExcludedStepKey = () =>
        CompleteStepBusinessType.pmpExcluded;
      mergePayloadMap = StepService.getMergePayloadBySettingKey([
        CompleteStepBusinessType.procedureOwner.settingKey,
        CompleteStepBusinessType.pmpExcluded.settingKey,
      ]);
    }

    ApproveChangePPOService.getPrimaryProcedureOwnerStepItem(
      param,
      (response: any) => this._getPrimaryProcedureOwnerStepItemSuccess(response, result),
      this._getPrimaryProcedureOwnerStepItemFailed,
      undefined,
      {
        ...mergePayloadMap,
        ...StepService.getMergePayloadBySettingKey([CompleteStepBusinessType.taskInfo.settingKey]),
      }
    );
  };

  _getFlowDataFailed = () => {
    this._alertError("Get PPO Flow Data Failed");
  };

  getFlowData = () => {
    const parentPageData = this._getRoutingParam("ParentPage");
    const param = {
      // @ts-ignore
      taskID: this.taskID,
      // @ts-ignore
      procedureID: this.procedureID,
      // @ts-ignore
      procedureStepID: this.procedureStepID,
      parentPage: parentPageData,
    };

    ApproveChangePPOService.getFlowStepData(
      param,
      (response: any) => this._getFlowDataSuccess(response, param),
      this._getFlowDataFailed
    );
  };

  componentDidMount() {
    this._showLoading();
    this.getFlowData();
  }

  render() {
    const { receiveDate, requestByName, procedureStepStatus } = this.state.pageHeadState;
    const { loading, taskInformationData, shareTask, procedureInfoState, jbProcedureSavedIn } =
      this.state;
    const { procedureTableData, clientServerPath, savedInRadioValue } =
      this.state.procedureFileData;
    const procedureData = {
      ...procedureInfoState,
      // @ts-ignore
      procedureID: this.procedureID,
      // @ts-ignore
      procedureStepID: this.procedureStepID,
    };
    const params = {
      // @ts-ignore
      TaskId: this.procedureTaskId,
      // @ts-ignore
      ProcedureID: this.procedureID,
      // @ts-ignore
      ProcedureStepID: this.procedureStepID,
    };

    const isReassignPending = procedureStepStatus === "Pending";
    const isReassignComplete = procedureStepStatus === "Complete";

    return (
      // @ts-ignore
      <NormalSpin spinning={loading} size="large" zIndex={1500}>
        <div className={styles.body} data-testid="reassign-ppo-container">
          <div className={styles.header}>
            <PageHeader
              title="Change Primary Procedure Owner"
              receiveDate={this._formateDate(receiveDate)}
              requestBy={requestByName}
              status={procedureStepStatus ? (isReassignPending ? "Pending" : "Complete") : ""}
            />
          </div>
          <ProcedureBlock
            className={styles.approveProcedureBlock}
            child={<TaskInformation data={taskInformationData} />}
            testid="task-info-block-arrow"
            isShowArrow={true}
            isOpen={false}
            onShowDataLoad={() => {
              // @ts-ignore
              return StepService.getStepData(
                {
                  procedureStepId: params.ProcedureStepID,
                  procedureTaskId: params.TaskId,
                  isHistorical: isReassignComplete,
                },
                this.setTaskInfoData,
                this.setError,
                [StepBusinessType.taskInfo]
              );
            }}
          />
          <ProcedureBlock
            child={
              <ReadOnlyProcedureFileSection
                procedureFileData={procedureTableData}
                procedureFileRef={procedureFileRef}
                clientServerPath={clientServerPath}
                savedInRadioValue={savedInRadioValue}
                jbProcedureSavedIn={jbProcedureSavedIn}
              />
            }
            testid="procedure-file-block-arrow"
            isShowArrow={true}
            isOpen={false}
            onShowDataLoad={() => {
              return StepService.getStepData(
                params,
                this.setProcedureFileData,
                this.setError,
                [
                  isReassignComplete
                    ? CompleteStepBusinessType.procedureFile
                    : StepBusinessType.procedureFile,
                ],
                StepService.getMergePayloadBySettingKey([
                  CompleteStepBusinessType.procedureFile.settingKey,
                ])
              );
            }}
          />
          <ProcedureBlock
            child={
              <ReadOnlySupportingFileSection
                supportingFileRef={supportingFileRef}
                supportingFileData={this.state.supportingFileData}
              />
            }
            testid="supporting-file-block-arrow"
            isShowArrow={true}
            isOpen={false}
            onShowDataLoad={() => {
              return StepService.getStepData(
                params,
                this.setSupportingFileData,
                this.setError,
                [
                  isReassignComplete
                    ? CompleteStepBusinessType.supportingFile
                    : StepBusinessType.supportingFile,
                ],
                StepService.getMergePayloadBySettingKey([
                  CompleteStepBusinessType.supportingFile.settingKey,
                ])
              );
            }}
          />
          <ProcedureBlock
            className={styles.ProcedureInfoSection}
            child={
              // @ts-ignore
              <ReassignProcedureInformation
                ref={procedureInfoRef}
                procedureTaskId={(this as any).procedureTaskId}
                procedureData={procedureData}
                submitData={procedureInfoState}
                noteDisabled={true}
                isPPODisabled={true}
                title="Procedure Information"
                closePage={this.closePage}
                isReassignPending={isReassignPending}
                _showLoading={this._showLoading}
                _hideLoading={this._hideLoading}
                params={params}
              />
            }
            testid="reassign-ppo-block-arrow"
            isShowArrow={true}
            isOpen={true}
          />
          <ProcedureBlock
            className={styles.approveProcedureBlock}
            child={<ActiveShareTaskReadOnly shareTaskData={shareTask} />}
            testid="share-task-block-arrow"
            isShowArrow={true}
            onShowDataLoad={() => {
              // @ts-ignore
              return StepService.getStepData(
                {
                  ...params,
                  isHistorical: isReassignComplete,
                  isShareTaskProcess: false,
                },
                this.setShareTaskData,
                this.setError,
                [StepBusinessType.shareTask]
              );
            }}
          />
        </div>
      </NormalSpin>
    );
  }
}
